module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av632-9489f5c003725a26bdf0f6dc26d1b30f.jpg";